import { render, staticRenderFns } from "./HeaderBasketDropdownNew.vue?vue&type=template&id=135e943f"
import script from "./HeaderBasketDropdownNew.vue?vue&type=script&lang=js"
export * from "./HeaderBasketDropdownNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports